import { render } from "./ClassDeclareConfirm.vue?vue&type=template&id=29a8361d&scoped=true"
import script from "./ClassDeclareConfirm.vue?vue&type=script&lang=js"
export * from "./ClassDeclareConfirm.vue?vue&type=script&lang=js"

import "./ClassDeclareConfirm.vue?vue&type=style&index=0&id=29a8361d&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a8361d"]])

export default __exports__